import { css } from "@emotion/react";

export const subHeaderStyle = css`
    font-weight: 600;
    font-size: 32px;
    line-height: 38px;
`;
